<!--
 * @Author: Ximen
 * @Date: 2021-03-17 15:46:49
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-07 14:39:30
-->
<template>
  <div class="bg">
    <div class="content">
      <a-card class="login" v-if="state=='resetPassword'">
        <div class="title">重置密码</div>
        <div class="components-input-demo-presuffix">
          <a-input-password class="infoInput" placeholder="请输入新密码"
           v-model:value="password">
            <template #prefix>
              <i class="iconfont icon-lock"></i>
            </template>
          </a-input-password>
          <a-input-password class="infoInput" placeholder="再次输入新密码"
           v-model:value="passwordAgain">
            <template #prefix>
              <i class="iconfont icon-lock"></i>
            </template>
          </a-input-password>
        </div>
        <a-button type="primary" class="loginBtn" @click="modifyPassword()">确定</a-button>
      </a-card>
      <a-card class="login" v-else>
        <div class="title">忘记密码</div>
        <div class="components-input-demo-presuffix">
          <a-input class="infoInput" placeholder="手机号码" v-model:value="mobile">
            <template #prefix>
              <i class="iconfont icon-mobile"></i>
            </template>
            <template #suffix>
              <a-tooltip title="Extra information">
                <info-circle-outlined style="color: rgba(0, 0, 0, 0.45)" />
              </a-tooltip>
            </template>
          </a-input>
          <a-input class="infoInput" placeholder="短信验证码"
           v-model:value="validCode">
            <template #prefix>
              <i class="iconfont icon-code"></i>
            </template>
            <template #suffix>
              <a class="colorBlue" @click="sendResetCode()">获取验证码</a>
            </template>
          </a-input>
        </div>
        <a-button type="primary" class="loginBtn" @click="nextStep()">下一步</a-button>
      </a-card>
      <p class="copyRight">© 2012 - 2021 seatent.com</p>
    </div>
  </div>
</template>
<script lang="ts">
// @ is an alias to /src
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import { message as $message } from 'ant-design-vue';
// import environment from '@/untils/environment';

export default defineComponent({
  name: 'Login',
  components: {
  },
  data() {
    return {
      loginState: 'login',
      isPassWord: false,
      mobile: '',
      validCode: '',
      parentInviteCode: '',
      password: '',
      passwordAgain: '',
      state: '',
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    console.log(this.$route);
    this.mobile = this.$route.query.mobile as string;
  },
  methods: {
    sendResetCode() {
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      if (!this.mobile) {
        this.error('请输入手机号码');
        return;
      }
      commonApi.sendResetCode({ mobile: this.mobile })
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
          } else {
            this.error(message);
          // this.$message.error(message);
          }
        });
    },
    nextStep() {
      if (!this.mobile) {
        this.error('请输入手机号码');
        return;
      }
      if (!this.validCode) {
        this.error('请输入验证码');
        return;
      }
      // 校验验证码
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      const params = {
        mobile: this.mobile,
        validCode: this.validCode,
      };
      // 确认新密码
      commonApi.checkResetCode(params)
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            this.state = 'resetPassword';
          } else {
            this.error(message);
          }
        });
    },
    modifyPassword() {
      if (!this.password) {
        this.error('请输入新密码');
        return;
      }
      if (!this.passwordAgain) {
        this.error('请再次输入新密码');
        return;
      }
      if (this.password !== this.passwordAgain) {
        this.error('两次密码输入不一致，请重新输入');
        return;
      }
      console.log(123);
      const params = {
        mobile: this.mobile,
        password: this.password,
        confirmPassword: this.passwordAgain,
        validCode: this.validCode,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      // 确认新密码
      commonApi.modifyShopPassword(params)
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            this.success('修改成功');
            this.$router.push('/login');
          } else {
            this.error(message);
          }
        });
    },
  },
});
</script>
<style lang="stylus" scoped>
  .bg
    background url('../../assets/background.jpg') no-repeat;
    background-size 100% 100%
    width 100%
    .content
      height 100vh
      padding-top 226px
  .colorBlue
    color #3281DD
  .login
    margin 0 auto
    border-radius 20px
    width 420px
    .titleLogin
      font-size 24px
      font-weight bold
      color #073D7D
      margin-bottom 24px
      display flex
      div
        flex 1
        text-align center
        cursor pointer
    .title
      font-size 24px
      font-weight bold
      color #073D7D
      margin-bottom 24px
    .infoInput
      margin-bottom 20px
      height 50px
    .loginBtn
      width 100%
      height 50px
      margin-top 10px
      border-radius 5px
      background #3281DD
    .selected
      color #073D7D
      opacity 0.5
    .agreementInfo
      margin-top 34px
      display flex
      font-size 12px
      flex-direction row
      justify-content space-between
      .colBlue
        color #3281DD
  .copyRight
    position fixed
    bottom 26px
    font-size 12px
    color #989898
    width 100%
</style>
